export enum SecurePaymentError {
  MAKE_PAYMENT_FAILED,
  VERIFY_PAYMENT_FAILED,
}

export enum SecurePaymentStage {
  MAKING_PAYMENT,
  THREE_D_SECURE,
  VERIFY_PAYMENT,
  COMPLETE,
}

interface SecurePaymentMakingPaymentState {
  stage: SecurePaymentStage.MAKING_PAYMENT
}

interface SecurePayment3DSecureState {
  stage: SecurePaymentStage.THREE_D_SECURE
  url: string
}

interface SecurePaymentVerifyPaymentState {
  stage: SecurePaymentStage.VERIFY_PAYMENT
}

interface SecurePaymentCompleteState {
  stage: SecurePaymentStage.COMPLETE
}

export type SecurePaymentState =
  | SecurePaymentMakingPaymentState
  | SecurePayment3DSecureState
  | SecurePaymentVerifyPaymentState
  | SecurePaymentCompleteState

interface SecurePaymentCompleteErrorEvent {
  success?: never
  error: SecurePaymentError
}

interface SecurePaymentCompleteSuccessEvent {
  success: {
    used3dSecure: boolean
  }
  error?: never
}

export type SecurePaymentCompleteEvent =
  | SecurePaymentCompleteErrorEvent
  | SecurePaymentCompleteSuccessEvent
